// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".is-expanded[data-v-38a8f2d3]{z-index:1}.menu-list[data-v-38a8f2d3]{position:absolute;display:block;background-color:#fff;width:100%;overflow:auto;border:1px solid #d3d3d3;z-index:auto}input[data-v-38a8f2d3]{box-shadow:none}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
